export default __webpack_public_path__ + "static/media/coalition-building.5fa282e1.png";